import {
    CcLibraryItem,
    CcLibraryItemList,
    CcComplianceRevision,
    CcComplianceHistory,
    CcComplianceItemState,
} from "server/models"
import { inferLiteral, StateType } from "client/utils"
import { TableGroupedIds } from "client/components"
import { CcLibrarySetList } from "client/store"
import * as types from "./types"

// list
export const setCcComplianceBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.CC_COMPLIANCE_BASE_ROUTE),
    baseRoute,
})
export const showCcComplianceColumnSettings = (show: boolean) => ({
    type: inferLiteral(types.CC_COMPLIANCE_COLUMN_SETTINGS),
    show,
})


export const setCcComplianceItemList = (itemList: CcLibraryItemList) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_LIST),
    itemList,
})
export const setCcComplianceItemGroupedIds = (setId: number, groupedIds: TableGroupedIds) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_GROUPED_IDS),
    setId,
    groupedIds,
})


export const setCcComplianceSetList = (setList: CcLibrarySetList) => ({
    type: inferLiteral(types.CC_COMPLIANCE_SET_LIST),
    setList,
})
export const setCcComplianceSetIds = (setIds: readonly number[]) => ({
    type: inferLiteral(types.CC_COMPLIANCE_SET_IDS),
    setIds,
})


export const setCcComplianceRevisionList = (setId: number, revisions: CcComplianceRevision[]) => ({
    type: inferLiteral(types.CC_COMPLIANCE_REVISION_LIST),
    setId,
    revisions,
})
export const setCcComplianceRevisionActive = (setId: number, revision: CcComplianceRevision) => ({
    type: inferLiteral(types.CC_COMPLIANCE_REVISION_ACTIVE_LIST),
    setId,
    revision,
})


export const setCcComplianceItemStateList = (setId: number, itemStateList: types.ComplianceStateList) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_STATE_LIST),
    setId,
    itemStateList,
})
export const setCcComplianceItemHistoryList = (setId: number, itemHistoryList: types.ComplianceHistoryList) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_HISTORY_LIST),
    setId,
    itemHistoryList,
})
export const setCcComplianceTempAnswerList = (setId: number, tempAnswerList: types.ComplianceTempAnswerList) => ({
    type: inferLiteral(types.CC_COMPLIANCE_TEMP_ANSWER_LIST),
    setId,
    tempAnswerList,
})


export const setCcComplianceSelectedItemIds = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_COMPLIANCE_SELECTED_ITEM_IDS),
    selected,
})
export const setCcComplianceVisibleItemIds = (visible: readonly number[]) => ({
    type: inferLiteral(types.CC_COMPLIANCE_VISIBLE_ITEM_IDS),
    visible,
})


export const setCcComplianceListLoadState = (state: StateType) => ({
    type: inferLiteral(types.CC_COMPLIANCE_LIST_LOAD_STATE),
    state,
})
export const setCcComplianceReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_COMPLIANCE_RELOAD_LIST),
    value,
})


// popup menu
export const setCcComplianceActive = (active: CcLibraryItem) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ACTIVE),
    active,
})
export const setCcCompliancePopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.CC_COMPLIANCE_POPUP_MENU_SHOW),
    show,
})
export const setCcCompliancePopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.CC_COMPLIANCE_POPUP_MENU_TARGET),
    target,
})


// view history
export const setCcComplianceItemDetails = (details: CcLibraryItem) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_DETAILS),
    details,
})
export const setCcComplianceItemState = (state: CcComplianceItemState) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_STATE),
    state,
})
export const setCcComplianceItemHistory = (history: CcComplianceHistory[]) => ({
    type: inferLiteral(types.CC_COMPLIANCE_ITEM_HISTORY),
    history,
})
export const setCcComplianceTempAnswers = (answers: types.ComplianceTempAnswerByUser) => ({
    type: inferLiteral(types.CC_COMPLIANCE_TEMP_ANSWERS),
    answers,
})
export const setCcComplianceTempAnswerVersions = (versions: types.ComplianceTempAnswerVersionByUser) => ({
    type: inferLiteral(types.CC_COMPLIANCE_TEMP_ANSWER_VERSIONS),
    versions,
})
export const setCcComplianceTempAnswerHistory = (history: CcComplianceHistory) => ({
    type: inferLiteral(types.CC_COMPLIANCE_TEMP_ANSWER_HISTORY),
    history,
})
export const setCcComplianceReloadAnswer = (value: boolean) => ({
    type: inferLiteral(types.CC_COMPLIANCE_RELOAD_ANSWER),
    value,
})
